




































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import moment from 'moment'
import {$} from 'simpli-web-sdk'
import {snakeCase} from 'lodash'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryMovement.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDelivery},
})
export default class ReportsDeliveryMovementView extends Mixins(MixinFilter) {
  AppConfig = AppConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)

  shown = ['sigla', 'insumo', 'tipoFinalizacao', 'tipoCriacao', 'slaStatus', 'manifesto']

  created() {
    this.filter.dateBy = 'dataCriacao,dataFinalizacao'

    if (this.$route.query.start === undefined) {
      this.filter.startDate = moment().format()
    }
  }

  async downloadData(xlsx = false) {
    const title = this.$t('view.reports.deliveryMovement.title') as string

    if (!xlsx) {
      await $.await.run(() => Helper.downloadCsv(
        title,
        '/user/carga/csv',
        this.filter,
        true,
        4,
      ), 'download')
    } else {
      await $.await.run(() => Helper.downloadXlsx(
        title,
        '/user/carga/csv',
        this.filter,
        Carga,
        'Carga',
        true,
        4,
        ), 'download')
    }
  }
}
